import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { DeleteOutline as DeleteIcon } from '@mui/icons-material'

interface DeleteIconProps extends IconButtonProps {
  fontSize: 'small' | 'medium'
}

export const DeleteIconButton: React.FC<DeleteIconProps> = ({
  fontSize,
  ...iconButtonProps
}) => {
  return (
    <IconButton aria-label='delete' {...iconButtonProps}>
      <DeleteIcon fontSize={fontSize} />
    </IconButton>
  )
}
